import { CONVERSATION_RATING_IDS as e } from "./conversation-ratings.js";
//#region src/constants/colors.ts
function t(e) {
	return `var(--${e})`;
}
var n = [
	"vis-azure",
	"vis-yellow",
	"vis-mint",
	"vis-salmon",
	"vis-slateblue",
	"vis-olive",
	"vis-pink",
	"vis-turquoise",
	"vis-orange",
	"vis-blue"
], r = {
	"fin.resolution_state": {
		confirmed_resolved: "vis-mint-40",
		assumed_resolved: "vis-mint-80",
		remaining: "gray-light"
	},
	"fin.participated": {
		0: "vis-azure-70",
		1: "vis-azure-40",
		remaining: "vis-azure-70"
	},
	"workflow_conversation_rating.rating_index": {
		[e.AMAZING]: "vis-green-40",
		[e.GREAT]: "vis-green-60",
		[e.OK]: "vis-yellow-70",
		[e.BAD]: "vis-yellow-50",
		[e.TERRIBLE]: "vis-salmon-40",
		Unknown: "gray"
	},
	"bot_conversation_rating.rating_index": {
		[e.AMAZING]: "vis-green-40",
		[e.GREAT]: "vis-green-60",
		[e.OK]: "vis-yellow-70",
		[e.BAD]: "vis-yellow-50",
		[e.TERRIBLE]: "vis-salmon-40",
		Unknown: "gray"
	},
	"conversation_rating.rating_index": {
		[e.AMAZING]: "vis-green-40",
		[e.GREAT]: "vis-green-60",
		[e.OK]: "vis-yellow-70",
		[e.BAD]: "vis-yellow-50",
		[e.TERRIBLE]: "vis-salmon-40",
		Unknown: "gray"
	},
	rating_index: {
		[e.AMAZING]: "vis-green-40",
		[e.GREAT]: "vis-green-60",
		[e.OK]: "vis-yellow-70",
		[e.BAD]: "vis-yellow-50",
		[e.TERRIBLE]: "vis-salmon-40",
		Unknown: "gray"
	},
	conversation_state: {
		opened: "vis-pink-50",
		snoozed: "vis-turquoise-50",
		closed: "vis-slateblue-50"
	},
	"user.location.continent_code": {
		AF: "vis-orange-50",
		AN: "vis-blue-50",
		AS: "vis-mint-50",
		EU: "vis-azure-50",
		NA: "vis-salmon-50",
		OC: "vis-yellow-50",
		SA: "vis-turquoise-50",
		Unknown: "gray"
	},
	channel_type: {
		"Android App": "vis-salmon-50",
		Desktop: "vis-azure-50",
		Email: "vis-yellow-50",
		Instagram: "vis-slateblue-50",
		"iOS App": "vis-mint-50",
		"Phone call": "vis-olive-50",
		"Phone switch": "vis-blue-50",
		SMS: "vis-orange-50",
		Twitter: "vis-pink-50",
		WhatsApp: "vis-turquoise-50",
		Unknown: "gray"
	},
	scorecard_outcome: {
		Pass: "vis-green-40",
		Fail: "vis-pink-70",
		"N/A": "neutral-container-emphasis",
		"Not scored": "neutral-border-emphasis",
		"Not complete": "gray"
	}
}, i = [
	[0, "vis-salmon-40"],
	[.25, "vis-yellow-50"],
	[.5, "vis-yellow-70"],
	[.75, "vis-green-60"],
	[1, "vis-green-40"]
], a = [
	[0, "vis-blue-70"],
	[.14, "vis-blue-70"],
	[.28, "vis-blue-60"],
	[.5, "vis-blue-50"],
	[.68, "vis-blue-40"],
	[.82, "vis-blue-30"],
	[1, "vis-blue-20"]
], o = [
	"conversation_rating.human.csat",
	"conversation_rating.human.csat.first_user_conversation_part_created_at",
	"conversation_rating.workflows.csat",
	"conversation_rating.ai_agent.csat",
	"conversation_rating.any_agent.csat"
];
//#endregion
export { r as COLOR_MAPPINGS, i as CSAT_COLOR_MAPPINGS, o as CSAT_METRICS, a as DEFAULT_HEATMAP_COLORS, n as SERIES_COLOR_PALETTE, t as tokenToCssVar };
